import React, {useEffect, useRef, useState} from 'react';
import BaseAPI from 'web/redux/actions/BaseAPI';
import store from 'web/redux/store';
import {Modal} from 'react-bootstrap';
import {showMessage} from 'web/utils/modalHelper';
import enumList from 'web/utils/enumList';

/**
 *
 */
export default function AssignmnetOrderEditModal({
  assignment = {},
  reloadData = () => {},
}) {
  const defaultFormValues = {
    salesOrderNo: '',
    invoiceNo: '',
    isQuoteCharged: false,
    quotationNo: '',
  };
  const [show, setShow] = useState(false);
  const [formValues, setFormValues] = useState(defaultFormValues);

  const handleChange = (e) => {
    const {name, value} = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const getOrder = async (assignmentId) => {
    const token = store.getState().auth.token;
    const data = await BaseAPI.getWithAuth(
      `/assignments/${assignmentId}`,
      null,
      token,
    );
    if (data.code.isSuccessCode()) {
      setFormValues({
        salesOrderNo: data.result.salesOrderNo,
        invoiceNo: data.result.invoiceNo,
        isQuoteCharged: data.result.isQuoteCharged,
        quotationNo: data.result.quotationNo,
      });
    } else {
      console.error(data);
      showMessage('error', '發生錯誤');
    }
  };

  const updateOrder = async () => {
    const token = store.getState().auth.token;
    try {
      const data = await BaseAPI.putWithAuth(
        `/assignments/${assignment.assignmentId}`,
        formValues,
        token,
      );
      if (data.code.isSuccessCode()) {
        reloadData();
        handleClose();
        showMessage(enumList.messageModalMode.info, '更新成功');
      } else {
        console.error(data);
        throw new Error();
      }
    } catch (error) {
      console.error(error);
      showMessage(enumList.messageModalMode.error, '發生錯誤');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateOrder();
  };

  useEffect(() => {
    if (assignment) {
      setShow(true);
      getOrder(assignment.assignmentId);
    }
  }, [assignment]);

  const handleClose = () => {
    setShow(false);
    setFormValues(defaultFormValues);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      className="edit-order-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title fs-5 ">填寫派工單號</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="col-12 d-flex gap-2 mb-2">
            <div className="col-6">
              <label htmlFor="customer-modal-longitude" className="form-label">
                銷貨單號
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="salesOrderNo"
                onChange={handleChange}
                value={formValues.salesOrderNo || ''}
                maxLength={50}
              />
            </div>
            <div className="col-6">
              <label htmlFor="customer-modal-latitude" className="form-label">
                發票號碼
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="invoiceNo"
                value={formValues.invoiceNo || ''}
                maxLength={50}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-6 ">
            <div className="d-flex align-items-center gap-1">
              <input
                id="isQuoteCharged"
                type="checkbox"
                name="isQuoteCharged"
                checked={formValues.isQuoteCharged}
                onChange={() => {
                  const nextState = !formValues.isQuoteCharged;
                  setFormValues({
                    ...formValues,
                    isQuoteCharged: nextState,
                    quotationNo: !nextState ? '' : formValues.quotationNo,
                  });
                }}
              />
              <label className="form-label m-0" htmlFor="isQuoteCharged">
                依報價單內容收費
              </label>
            </div>

            <input
              type="text"
              className="form-control form-control-sm"
              name="quotationNo"
              disabled={!formValues.isQuoteCharged}
              value={formValues.quotationNo || ''}
              onChange={handleChange}
              placeholder="報價單號"
              maxLength={11}
            />
          </div>
          <div className="d-flex justify-content-between mt-3 gap-2 ">
            <button
              className="btn btn-cancel w-50"
              type="button"
              onClick={handleClose}
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary w-50">
              儲存
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
